<div class="error-container">
  <div class="error-card">
    <span class="error-icon">{{ icon }}</span>
    <h1 class="error-title">{{ title }}</h1>
    <p class="error-message">{{ errorMessage() }}</p>
    <p class="error-help">Si le problème persiste, veuillez contacter l'administrateur.</p>
  </div>
</div>
